import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { Observable, of } from 'rxjs';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';
import { AuthState, AuthStore } from './auth.store';
import { IUserProfileDto, UserGroupEnum } from '@nft-folks/interfaces';

@Injectable({ providedIn: 'root' })
export class AuthQuery extends Query<AuthState> {
  constructor(protected override store: AuthStore) {
    super(store);
  }

  isAuthenticated$: Observable<boolean> = this.select((state) => !!state?.meta?.token);
  meId$: Observable<number | undefined> = this.select((state) => state?.profile?.id);
  profile$: Observable<IUserProfileDto> = this.select((state) => state?.profile).pipe(
    filter((x): x is IUserProfileDto => !!x),
  );
  userGroup$ = this.select((state) => state.profile?.groupId);
  isAdmin$ = this.userGroup$.pipe(map((group) => group === UserGroupEnum.ADMIN));
  get profile(): IUserProfileDto | null {
    return this.getValue().profile;
  }

  get isAuthenticated(): boolean {
    return !!this.getValue().meta?.token;
  }

  getMeId(): number {
    return this.getValue()?.profile?.id as any;
  }

  getIsAdmin(): boolean {
    return this.getValue()?.profile?.groupId === UserGroupEnum.ADMIN;
  }

  selectMeId(): Observable<number> {
    return this.select((state) => state?.profile?.id) as any;
  }
}
